module.exports = `${require.publicPath}logo.e46ffc19.png`;